<template>
  <v-container class="pa-0">
    <v-row v-if="value && value.includes" row dense wrap>
      <v-col
        class="col-12 pa-0"
        v-for="(group, index) in value.includes"
        :key="group.id"
      >
        <v-row row dense wrap>
          <v-col class="col-12 pa-0">
            <div v-if="index > 0" class="ml-3 application-heading">AND</div>
            <KeywordChipEditor
              v-model="group.keywords"
              label="Include"
              :groupId="group.id"
              :disableInput="disableInput"
              :chip="includeChip"
              :chipSuggestion="includeChipSuggestion"
              @keyword-group-remove="handleKeywordGroupRemove"
            ></KeywordChipEditor>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="col-12 pl-4">
        <v-btn solo x-small :disabled="disableInput" @click="addKeywordGroup">
          ADD MORE KEYWORDS
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="value && value.excludes" dense row wrap>
      <v-col class="col-12 pa-0">
        <KeywordChipEditor
          v-model="value.excludes"
          label="Exclude"
          :disableInput="disableInput"
          :chip="excludeChip"
          :chipSuggestion="excludeChipSuggestion"
          @keyword-group-remove="handleKeywordExcludesRemoveAll"
        ></KeywordChipEditor>
      </v-col>
    </v-row>

    <v-row dense row wrap>
      <v-col class="ml-2">
        <div
          class="keyword-limit-display"
          v-bind:class="{ 'limit-exceeded': overLimit }"
        >
          {{ currentKeywordCount }}/{{ keywordLimit }} Keywords
        </div>
      </v-col>
    </v-row>
    <v-row v-if="overLimit" dense row wrap>
      <v-col class="ml-2">
        <span class="keyword-limit-display limit-exceeded">
          Too many keywords. Please remove keywords before continuing.
        </span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import lodashGet from "lodash/get";
import lodashFindLastIndex from "lodash/findLastIndex";

import { KEYWORD_MAX_LIMIT } from "@/common/constants/savedSearch.js";

export default {
  name: "KeywordEditor",
  components: {
    KeywordChipEditor: () =>
      import("@/components/common/keywords/KeywordChipEditor"),
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    keywordLimit: {
      type: Number,
      default: KEYWORD_MAX_LIMIT,
    },
  },
  data() {
    let idCounter = 1;
    if (lodashGet(this.value, "includes")) {
      this.value.includes.forEach((item) => {
        item.id = idCounter;
        idCounter++;
      });
    }

    return {
      includeChip: {
        font: "#ffffff",
        color: "#4c8c4b",
      },
      includeChipSuggestion: {
        font: "#ffffff",
        color: "#81bd83",
      },
      excludeChip: {
        font: "#ffffff",
        color: "#a44e4e",
      },
      excludeChipSuggestion: {
        font: "#ffffff",
        color: "#cd7777",
      },
      idCounter: idCounter,
    };
  },
  mounted() {
    if (lodashGet(this.value, "includes") && this.value.includes.length === 0) {
      this.addKeywordGroup();
    }
    if (!lodashGet(this.value, "excludes")) {
      this.value.excludes = [];
    }
  },
  computed: {
    currentKeywordCount() {
      const excludesCount =
        this.value && this.value.excludes ? this.value.excludes.length : 0;
      return this.value.includes.reduce((total, include) => {
        total += include.keywords ? include.keywords.length : 0;
        return total;
      }, excludesCount);
    },
    overLimit() {
      return this.currentKeywordCount > this.keywordLimit;
    },
    disableInput() {
      return this.currentKeywordCount >= this.keywordLimit;
    },
  },
  methods: {
    addKeywordGroup() {
      if (lodashGet(this.value, "includes")) {
        this.value.includes.push({
          id: this.idCounter,
          keywords: [],
        });
        this.idCounter++;
      }
    },
    handleKeywordGroupRemove(group) {
      const index = lodashFindLastIndex(this.value.includes, [
        "id",
        group.groupId,
      ]);
      if (this.value.includes.length === 1) {
        return (this.value.includes[0].keywords = []);
      }
      return this.value.includes.splice(index, 1);
    },
    handleKeywordExcludesRemoveAll() {
      this.value.excludes = [];
    },
  },
  watch: {
    value: {
      handler() {
        if (
          lodashGet(this.value, "includes") &&
          this.value.includes.length === 0
        ) {
          this.addKeywordGroup();
        }
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.keyword-limit-display {
  font-size: 12px;
  color: #959595;
}
.limit-exceeded {
  color: #ff5252 !important;
}
</style>
